import {
  Component,
  OnInit,
  ViewChild,
  EmbeddedViewRef,
  ViewContainerRef,
  Input,
  TemplateRef,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

@Component({
  selector: 'portal',
  templateUrl: './portal.component.html',
})
export class PortalComponent implements AfterViewInit, OnDestroy {
  @Input() public portalHostSelector: string;
  private viewRef: EmbeddedViewRef<{}>;
  @ViewChild('portalTemplate', { static: true }) private portalActionsTmplRef: TemplateRef<any>;

  constructor(private viewContainerRef: ViewContainerRef) {}

  public ngAfterViewInit(): void {
    this.viewRef = this.viewContainerRef.createEmbeddedView(
      this.portalActionsTmplRef,
    );
    this.viewRef.detectChanges();
    const outletElement = document.querySelector(this.portalHostSelector);
    this.viewRef.rootNodes.forEach(rootNode =>
      outletElement.appendChild(rootNode),
    );
  }

  public ngOnDestroy(): void {
    const index = this.viewContainerRef.indexOf(this.viewRef);
    if (index !== -1) this.viewContainerRef.remove(index);
  }
}
